import Modal from './components/modal'

$(document).ready(function () {
  // carousel Team
  if($('.team').length > 0) {
    $( ".team_row" ).each(function() {
      var id_carousel = $(this).find('.carousel-team-soingeur').attr('id')
      var id_dots = $(this).find('.dots-team-soingeur').attr('id')
      var id_prev = $(this).find('.glider-prev').attr('id')
      var id_next = $(this).find('.glider-next').attr('id')
      const carouselTeamS = document.querySelector('#'+id_carousel)
      if (carouselTeamS) {
        new Glider(carouselTeamS, {
          dots: '#'+id_dots,
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: {
            prev: '#'+id_prev,
            next: '#'+id_next
          },
          draggable: true,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 3.4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1
              }
            }
          ]
        })
      }
      if(($(this).find('#'+id_dots).children().length < 2 )) {
        $(this).find(".glider__container-dots").hide();
        $(this).find(".glider-prev").hide();
        $(this).find(".glider-next").hide();
      }
    });
  }
  if($('.modal-team').length > 0) {
    $( ".modal-team" ).each(function() { 
      var popup = $(this).attr("id");
      const modal = new Modal('#'+popup)
      // code pour ouvrir la modal
      var btn = document.querySelector('#'+popup+'-btn')
      if (btn != null) {
        btn.addEventListener('click', (e) => {
          e.preventDefault()
          modal.open()
        })
      }
    });
  }
});